import dayjs from 'dayjs';

const Setting = class Setting {
    constructor() {
        this.id = null;
        this.name = '';
        this.type = '';
        this.value = '';
        this.data = {};
        this.createdAt = dayjs().format('YYYY-MM-DD');
        this.updatedAt = dayjs().format('YYYY-MM-DD');
    }
};

export default Setting;
